import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=190c0373&scoped=true&"
import script from "./MessageCard.vue?vue&type=script&lang=js&"
export * from "./MessageCard.vue?vue&type=script&lang=js&"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=190c0373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c0373",
  null
  
)

export default component.exports